// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__C4w0g","avatar__lg":"Avatar_avatar__lg__FxHG0","avatar__iscurrentuser":"Avatar_avatar__iscurrentuser__fh8cC"};